export enum ChannelId {
  aripaev = 'aripaev',
  dv = 'dv',
  investoruklubs = 'investoruklubs',
  kalastaja = 'kalastaja',
  ajalugu = 'ajalugu',
  teadus = 'teadus',
}
